import { render, staticRenderFns } from "./orderByWorkshop.vue?vue&type=template&id=0503a57b&scoped=true"
import script from "./orderByWorkshop.vue?vue&type=script&lang=js"
export * from "./orderByWorkshop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0503a57b",
  null
  
)

export default component.exports